import trophy from "../../assets/images/trophy.svg"

export const counterData = [
    {
        img: trophy,
        heading: "1500",
        span: "+",
        title: "hours to work"
    },
    {
        img: trophy,
        heading: "80",
        span: "+",
        title: "happy clients"
    },
    {
        img: trophy,
        heading: "75",
        title: "launched apps"
    },
    {
        img: trophy,
        heading: "12",
        title: "design awards"
    },
]